export default __webpack_public_path__ + "static/media/asignado_activo.10adeb48.png";